import { Component } from '@angular/core';
import { MotifProgressLoaderModule } from '@ey-xd/ng-motif';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'app-progress-loader',
  imports: [MotifProgressLoaderModule, TranslatePipe, TranslateDirective],
  templateUrl: './progress-loader.component.html',
  styleUrl: './progress-loader.component.scss',
})
export class ProgressLoaderComponent {}
